export default __webpack_public_path__ + "static/media/3.a51cbe06.svg";